<mat-card class="example-card biggest-container">
  <mat-card-content>
    <mat-toolbar style="margin-bottom: 10px" color="primary"
      ><span>Liste articles</span></mat-toolbar
    >
    <div fxLayout="row">
      <div style="margin-right: 20px" class="button-row">
        <button (click)="modifier()" mat-raised-button class="colorGreen">
          Modifier
        </button>
      </div>
      <div style="margin-right: 20px" class="button-row">
        <button (click)="afficher()" mat-raised-button class="colorGreen">
          Consulter
        </button>
      </div>
      <div style="margin-right: 20px" class="button-row">
        <button
          [disabled]="disabledBtnSupprimer"
          (click)="supprimer()"
          mat-raised-button
          class="colorReed"
        >
          Supprimer
        </button>
      </div>
    </div>
    <br />
    <app-recherche
      recherche="ecarticleauto2"
      displayColumn="Art_Des"
      name="article"
      placeholder="Article"
    ></app-recherche>
    <!-- <mat-form-field>
          <input matInput [(ngModel)]="tttt" placeholder="Filter">
        </mat-form-field>
      <div *ngIf="exist;else attente">
        <div fxLayout="row" fxLayoutAlign="space-between none" >
          <mat-form-field>
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
          </mat-form-field>
          <div fxLayout="row">            
            <div  style="margin-right: 20px" class="button-row">
              <button (click)="modifier()" mat-raised-button class="colorGreen">Modifier</button>
            </div>
            <div  style="margin-right: 20px" class="button-row">
              <button (click)="afficher()" mat-raised-button class="colorGreen">Consulter</button>
            </div>
            <div  style="margin-right: 20px"  class="button-row">
              <button (click)="supprimer()" mat-raised-button class="colorReed">Supprimer</button>
            </div>         
          </div>
        </div>
        <div [ngStyle]="divStyle" class="mat-elevation-z8">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                <ng-container matColumnDef="Art_Code">
                  <th mat-header-cell *matHeaderCellDef> Code </th>
                  <td mat-cell *matCellDef="let element"> {{element.Art_Code}} </td>
                </ng-container>
                <ng-container matColumnDef="Art_Des">
                  <th mat-header-cell *matHeaderCellDef> Désignation </th>
                  <td mat-cell *matCellDef="let element"> {{element.Art_Des}} </td>
                </ng-container>
              
                <ng-container matColumnDef="Art_DelaiProd">
                  <th mat-header-cell *matHeaderCellDef> Durée garantie </th>
                  <td mat-cell *matCellDef="let element"> {{element.Art_DelaiProd}} </td>
                </ng-container>
              
                <ng-container matColumnDef="Art_PV">
                  <th mat-header-cell *matHeaderCellDef> Prix </th>
                  <td mat-cell *matCellDef="let element"> {{element.Art_PV}} </td>
                </ng-container>
              
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRow($event,row)"></tr>
              </table>
        </div>
      </div> -->
  </mat-card-content>
</mat-card>
<ng-template #attente>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
